import * as React from 'react';
import { useMobileApi } from '../../../Api/Mobile/useMobileApi';
import { MobileWealthDTO, MobileWealthVovClient } from '../../../ApiOld/Api/ApiServerVov';
import { Box, Fab, IconButton, Stack, Typography } from '@mui/material';
import GridCompactView from '../../Shared/Datagrid/GridCompactView';
import { AddCircle } from '@mui/icons-material';
import { useEmployeeContext } from '../../../Contexts/Providers/EmployeeLayoutProvider';
import { useNavigate, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useState } from 'react';
import LoadingIndicator from '../Shared/LoadingIndicator';
import PersonIcon from '@mui/icons-material/Person';
import { Hardware } from '@mui/icons-material';
import CheckIcon from '@mui/icons-material/Check';
import DomainOutlinedIcon from '@mui/icons-material/DomainOutlined';
import DateRangeIcon from '@mui/icons-material/DateRange';

export interface IMobileWealthProps {
}

export default function MobileWealth(props: IMobileWealthProps) {
    const { authorizedMobileEmployeeApi } = useMobileApi(MobileWealthVovClient);
    const { getFirstPartPath, setModuleButton, setModuleName } = useEmployeeContext();
    const params = useParams();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [borrowedWealth, setBorrowedWealth] = React.useState<MobileWealthDTO[]>([]);
    const [loaded, setLoaded] = useState(false);
    const getBorrowedWealth = React.useCallback(async () => {
        await authorizedMobileEmployeeApi.employeesWealth().then((res) => {
            setLoaded(true);
            setBorrowedWealth(res.wealth ?? []);
        }).catch(() => {
            setLoaded(true);
        });
    }, [authorizedMobileEmployeeApi]);
    React.useEffect(() => {
        getBorrowedWealth();
    }, [getBorrowedWealth]);

    if (!loaded) {
        return <LoadingIndicator />
    }
    return (
        <Box p={2}>
            <GridCompactView<MobileWealthDTO>
                onMobileListItemClick={(item) => {
                    setModuleButton(
                        <IconButton onClick={() => {
                            window.history.back();
                            setModuleName('Wealth');
                            setModuleButton && setModuleButton(null);
                        }}>
                            <ArrowBackIosNewIcon />
                        </IconButton>
                    );
                    navigate(getFirstPartPath(params.lang ?? 'cs') + 'employee/wealth/' + item.wealthId);
                }}
                data={borrowedWealth}
                sxCompactViewBox={{ boxShadow: 2, borderRadius: 4, m: 1 }}
                getCompactTemplate={(data, index) => {
                    let isLast = index === borrowedWealth.length - 1;
                    return <Box key={data.wealthId} sx={{
                        px: 2,
                    }}>
                        <Box

                            sx={{ width: '100%', py: 0.5, borderBottom: isLast ? 'none' : '1px solid #ccc', }}>
                            <Stack direction="row" spacing={1} alignContent={'center'}>
                                <Hardware sx={{ color: '#FFC600' }} />
                                <Typography sx={{ fontSize: 16, fontWeight: 'bold', lineHeight: 1 }}>{data.code} - {data.name}</Typography>
                            </Stack>
                            {data.buildingCodeAndName && (
                                <Stack direction="row" spacing={1} alignItems={'center'}>
                                    <DomainOutlinedIcon sx={{ color: '#FFC600' }} />
                                    <Typography sx={{ fontSize: 15, lineHeight: 1 }}>{data.buildingCodeAndName}</Typography>
                                </Stack>
                            )}
                            {(data.rentDateFrom || data.rentDateTo) && data.employeeCodeAndName &&
                                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                                    <DateRangeIcon sx={{ color: '#FFC600' }} />
                                    <Stack direction="row" spacing={1} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                        <Typography sx={{ fontSize: 15, lineHeight: 1 }}>
                                            {data.rentDateTo && (
                                                <span style={{ color: new Date(data.rentDateTo) < new Date() ? 'red' : 'inherit' }}>
                                                    {`${t('to').toLowerCase()} ${data.rentDateTo.toLocaleDateString(i18n.language)}`}
                                                </span>
                                            )}
                                        </Typography>
                                    </Stack>
                                </Box>
                            }
                        </Box>
                    </Box>
                }}

                propsToFilter={[{ name: 'name', type: 'string' }, { name: 'code', type: 'string' }]}
                propsToSort={[{ name: 'name', displayName: t('log.name') }]}
                searchPlaceholder={t('Search...')}
                noResultsText={t('noRecords')}
            />
            <Fab onClick={() => { navigate(getFirstPartPath(params.lang ?? 'cs') + 'employee/wealth-borrow') }} color="primary" aria-label="add" sx={{ position: 'fixed', bottom: 16, right: 16 }}>
                <AddCircle />
            </Fab>
        </Box>
    );
}
